export const formatDateTime = (v: any) => {
    if (!v) return "";
    const d = v instanceof Date ? v : new Date(v);
    if (Number.isNaN(d.getTime())) return String(v);
    return d.toLocaleString("tr-TR");
};

export const formatDate = (v: any) => {
    if (!v) return "";
    const d = v instanceof Date ? v : new Date(v);
    if (Number.isNaN(d.getTime())) return String(v);
    return d.toLocaleDateString("tr-TR");
};

export const formatTime = (v: any) => {
    if (!v) return "";
    const d = v instanceof Date ? v : new Date(v);
    if (Number.isNaN(d.getTime())) return String(v);
    return d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
};

export const getPainImage = (value: number | string, name?: string) => {
    const v = Number(value);
    const n = (name || "").toLowerCase();

    // Az -> image-3
    if (n.includes("az") || v === 1) return "/assets/icons/pages/nurse/patient-data/icons/partograf/partograf-image-3.svg";

    // Orta -> image-1
    if (n.includes("orta") || v === 2) return "/assets/icons/pages/nurse/patient-data/icons/partograf/partograf-image-1.svg";

    // Çok / Şiddetli -> image-4
    if (n.includes("şiddetli") || n.includes("siddetli") || n.includes("çok") || n.includes("cok") || v === 3 || v === 4) return "/assets/icons/pages/nurse/patient-data/icons/partograf/partograf-image-4.svg";

    return null;
};
